import type { Reward } from './shared.js';

const allocated = new Set(['approved', 'reserved', 'prepared', 'claimable', 'paid', 'payment_review']);

/** Only the records loaded on this page; never an onchain portfolio valuation. */
export function summarizeRewards(records: Reward[], preview = false) {
  const unique = [...new Map(records.map(record => [record.id, record])).values()];
  const summary = { submitted: unique.length, delivered: 0, waiting: 0, rejected: 0,
    assets: [] as { ticker: string; cents: number; receipts: number }[] };
  const assets = new Map<string, { ticker: string; cents: number; receipts: number }>();
  for (const record of unique) {
    if (!preview && record.status === 'paid' && record.deliveryVerified === true) summary.delivered++;
    else if (record.status === 'rejected') summary.rejected++;
    else summary.waiting++;
    if (!allocated.has(record.status) && !(preview && ['demo', 'preview'].includes(record.status))) continue;
    const value = record.rewardCents ?? (typeof record.usd === 'number' ? Math.round(record.usd * 100) : null);
    if (!Number.isSafeInteger(value) || value! < 0 || !record.ticker) continue;
    const ticker = record.ticker;
    const group = assets.get(ticker) || { ticker, cents: 0, receipts: 0 };
    if (!Number.isSafeInteger(group.cents + value!)) continue;
    group.cents += value!; group.receipts++; assets.set(ticker, group);
  }
  summary.assets = [...assets.values()].sort((a, b) => b.cents - a.cents || a.ticker.localeCompare(b.ticker));
  return summary;
}
